import client from "api/client";

const PATHS = {
  LOGIN: "/auth/local",
};

export const login = async (data) => {
  return await client.post(PATHS.LOGIN, data);
};

export const register = async (data) => {
  return await client.post("/auth/local/register", data);
};

export const forgotPassword = async (data) => {
  return await client.post("/auth/forgot-password", data);
};

export const resetPassword = async (data) => {
  return await client.post("/auth/reset-password", data);
};

export const changePassword = async (data) => {
  return await client.post("/auth/change-password", data);
};

export const getUser = async () => {
  return await client.get(`/users/me`);
};

export const updateUser = async (data) => {
  return await client.put(`/users/${data.id}`, data);
};
